<template>
    <div>
        <app-bar :title="t('groups_title')"></app-bar>

        <v-layout>
            <group-collection></group-collection>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import GroupCollection from '@/components/groups/GroupCollection.vue'

    export default defineComponent({
        components: {
            GroupCollection,
        },

        /**
         * @param props
         */
        setup(props) {
            const state = reactive({})

            return {
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>